<template>
  <div class="my-page">
    <el-card>
      <template #header>
        <div>
          <div class="page-title">
            <span>{{ PageTitle }}</span>
          </div>

          <el-form :inline="true" size="small">
            <el-form-item>
              <el-select v-model="departmentid" :placeholder="translateWords.DepartmentName">
                <el-option v-for="item in DepartmentDropList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input style="width:200px" v-model="spmc" :placeholder="translateWords.inputCommodityName"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="spbm" style="width:200px" :placeholder="translateWords.commodityBarCode"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="gsfj" :placeholder="translateWords.positionName" filterable @change="selectvalue(gsfj)">
                <el-option v-for="item in gsfjoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="hjh" filterable :placeholder="translateWords.selectRackLayer">
                <el-option v-for="item in hjhoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="Source" v-if="env != 'unico' && type != 'aigosampleformarketcenter'" filterable :placeholder="translateWords.Source">
                <el-option v-for="item in Sourceoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="IsCaseSensitive" filterable placeholder="是否区分大小写">
                <el-option v-for="item in CaseSensitiveOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query" v-if="PermissonList.Search.value">{{ translateWords.query }}</el-button>
            </el-form-item>
            <template v-if="false">
              <div>
                <el-form-item>
                  <el-input style="width: 300px" v-model="gysdm" :placeholder="translateWords.gysdm"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="xjp" filterable :placeholder="translateWords.selectneworold">
                    <el-option v-for="item in xjpoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select filterable v-model="zt" :placeholder="translateWords.selectstatus">
                    <el-option v-for="item in ztoptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </template>

            <template>
              <el-form-item>
                <el-button type="primary" @click="openrkrecord" v-if="PermissonList.InOutSearch.value">{{ translateWords.openrkrecord }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="openaddsampleforagbs" v-if="PermissonList.Add.value && env != 'unico' && type != 'aigosampleformarketcenter'">
                  {{ translateWords.addSample }}
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="openaddsample" v-if="PermissonList.Add.value && (env == 'unico' || type == 'aigosampleformarketcenter')">
                  {{ translateWords.addSample }}
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="openaddplsample" v-if="PermissonList.BatchAdd.value && env == 'unico'">{{ translateWords.pladdsample }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="exprotexcel" v-if="PermissonList.Export.value">{{ translateWords.Export }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-upload
                  v-if="PermissonList.UpLoad.value && (env == 'unico' || type == 'aigosampleformarketcenter')"
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :file-list="fileList"
                  :limit="1"
                  :before-upload="
                    (file) => {
                      return handleUploadBeforeUpload(file, 'sp');
                    }
                  "
                >
                  <el-button slot="trigger" type="primary">{{ translateWords.loadCommodity }}</el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-upload
                  v-if="PermissonList.UpLoadStock.value"
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :file-list="fileList"
                  :limit="1"
                  :before-upload="
                    (file) => {
                      return handleUploadBeforeUpload(file, 'pd');
                    }
                  "
                >
                  <el-button slot="trigger" type="primary">{{ translateWords.countStort }}</el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-upload
                  v-if="PermissonList.BatchDelete.value && env == 'unico'"
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :file-list="fileList"
                  :limit="1"
                  :before-upload="
                    (file) => {
                      return handleUploadBeforeUpload(file, 'batchdeleteproduct');
                    }
                  "
                >
                  <el-button slot="trigger" type="primary">
                    批量删除样品
                  </el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
              <template v-if="false">
                <!-- <el-form-item>
                  <el-upload
                    v-if="false"
                    class="upload-demo"
                    ref="upload"
                    :file-list="fileList"
                    :limit="1"
                    :before-upload="
                      (file) => {
                        return handleUploadBeforeUpload(file, 'batchupdaterack');
                      }
                    "
                  >
                    <el-button slot="trigger" type="primary">
                      批量修改货架货架层
                    </el-button>
                    <div slot="tip" class="el-upload__tip"></div>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-upload
                    v-if="false"
                    class="upload-demo"
                    ref="upload"
                    :file-list="fileList"
                    :limit="1"
                    :before-upload="
                      (file) => {
                        return handleUploadBeforeUpload(file, 'batchupdateregion');
                      }
                    "
                  >
                    <el-button slot="trigger" type="primary">
                      批量修改区域
                    </el-button>
                    <div slot="tip" class="el-upload__tip"></div>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-upload
                    v-if="false"
                    class="upload-demo"
                    ref="upload"
                    :file-list="fileList"
                    :limit="1"
                    :before-upload="
                      (file) => {
                        return handleUploadBeforeUpload(file, 'batchupdateposition');
                      }
                    "
                  >
                    <el-button slot="trigger" type="primary">
                      批量修改位置
                    </el-button>
                    <div slot="tip" class="el-upload__tip"></div>
                  </el-upload>
                </el-form-item> -->
              </template>
              <el-form-item>
                <el-upload
                  v-if="PermissonList.BatchDelete.value && env == 'unico'"
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :file-list="fileList"
                  :limit="1"
                  :before-upload="
                    (file) => {
                      return handleUploadBeforeUpload(file, 'batchupdateproductposition');
                    }
                  "
                >
                  <el-button slot="trigger" type="primary">
                    批量修改样品位置
                  </el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-upload
                  v-if="PermissonList.BatchUpdateStorage.value && env == 'unico'"
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :file-list="fileList"
                  :limit="1"
                  :before-upload="
                    (file) => {
                      return handleUploadBeforeUpload(file, 'batchupdatestorage');
                    }
                  "
                >
                  <el-button slot="trigger" type="primary">
                    批量修改样品库存
                  </el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-upload
                  v-if="PermissonList.BatchSplitSubCode.value && env == 'unico'"
                  class="upload-demo"
                  ref="upload"
                  action=""
                  :file-list="fileList"
                  :limit="1"
                  :before-upload="
                    (file) => {
                      return handleUploadBeforeUpload(file, 'batchsplitsubcode');
                    }
                  "
                >
                  <el-button slot="trigger" type="primary">
                    批量拆分样品位置
                  </el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-upload
                  v-if="PermissonList.BatchAddStorage.value && env == 'unico'"
                  class="upload-demo"
                  ref="upload"
                  :file-list="fileList"
                  :limit="1"
                  :before-upload="
                    (file) => {
                      return handleUploadBeforeUpload(file, 'batchaddstorage');
                    }
                  "
                >
                  <el-button slot="trigger" type="primary">
                    批量入库
                  </el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
            </template>

            <template>
              <el-form-item>
                <a :href="spmoban" v-if="PermissonList.DownLoadSampleTemplate.value && env == 'unico'">{{ translateWords.model }}</a>
                <a :href="kcmoban" v-if="PermissonList.DownLoadStockTemplate.value">{{ translateWords.repertoryModel }}</a>
              </el-form-item>
              <el-form-item v-if="PermissonList.BatchDelete.value && env == 'unico'">
                <a :href="batchdeletemoban">批量删除样品模板</a>
              </el-form-item>
              <el-form-item v-if="PermissonList.BatchDelete.value && env == 'unico'">
                <a :href="batchupdateproductpositionmoban">批量修改样品位置模板</a>
              </el-form-item>
              <el-form-item v-if="PermissonList.BatchUpdateStorage.value && env == 'unico'">
                <a :href="batchupdatestoragemoban">批量修改样品库存模板</a>
              </el-form-item>
              <el-form-item v-if="PermissonList.BatchSplitSubCode.value && env == 'unico'">
                <a :href="batchsplitsubcodemoban">批量拆分样品库存位置模板</a>
              </el-form-item>
              <el-form-item v-if="PermissonList.SearchCountryCode.value">
                <el-tooltip :content="countryid" placement="top">
                  <el-button>{{ translateWords.searchdepartmentid }}</el-button>
                </el-tooltip>
              </el-form-item>
              <el-form-item>
                <el-tooltip :content="productremark" placement="top" v-if="env == 'unico'">
                  <el-button>{{ translateWords.productremark }}</el-button>
                </el-tooltip>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="modelload" v-if="PermissonList.LangDownLoadSampleTemplate.value && env == 'unico'">{{ translateWords.modeldownload }}</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="doshowkeyrecord" v-if="PermissonList.SearchKeyRecord.value">{{ translateWords.querykey }}</el-button>
              </el-form-item>
              <template v-if="false">
                <!-- <el-form-item>
                  <a :href="batchupdaterackmoban" v-if="false">样品批量修改货架模板</a>
                  <a :href="batchupdateregionmoban" v-if="false">样品批量修改区域模板</a>
                  <a :href="batchupdatepositionmoban" v-if="false">样品批量修改位置模板</a>
                </el-form-item> -->
              </template>
            </template>
          </el-form>
        </div>
      </template>

      <div>
        <el-table :data="tableData" border highlight-current-row size="small" max-height="800">
          <el-table-column prop="Id" :label="translateWords.code"></el-table-column>
          <el-table-column v-if="false" prop="Sys_Guid" label="Sys_Guid"></el-table-column>

          <el-table-column prop="ProductName" :label="translateWords.commodityName" width="240" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="ProductCode" :label="translateWords.commodityBarCode" show-overflow-tooltip></el-table-column>
          <el-table-column width="150" prop="ProductType" :label="translateWords.commodityClassis" show-overflow-tooltip></el-table-column>
          <el-table-column
            width="150"
            prop="ModelType"
            v-if="env == 'unico' || type == 'aigosampleformarketcenter'"
            :label="translateWords.ModelType"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column width="1" prop="SupplierCode" :label="translateWords.supplierCode" v-if="false"></el-table-column>
          <el-table-column
            width="100"
            prop="NewOrOld"
            v-if="env != 'unico' && type != 'aigosampleformarketcenter'"
            :label="translateWords.newOrOld"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="SumStorage" :label="translateWords.sumStorage"></el-table-column>
          <el-table-column prop="CanBeUseStorage" :label="translateWords.canBeUseStorage"></el-table-column>
          <el-table-column
            width="150"
            prop="GoodsCode"
            v-if="env != 'unico' && type != 'aigosampleformarketcenter'"
            :label="translateWords.GoodsCode"
            show-overflow-tooltip
          ></el-table-column>

          <el-table-column
            width="100"
            prop="Unit"
            v-if="env != 'unico' && type != 'aigosampleformarketcenter'"
            :label="translateWords.Unit"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            width="120"
            prop="DesignedForName"
            v-if="env != 'unico' && type != 'aigosampleformarketcenter'"
            :label="translateWords.DesignedForName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            width="120"
            prop="GoodsSize"
            v-if="env != 'unico' && type != 'aigosampleformarketcenter'"
            :label="translateWords.GoodsSize"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="IsBig" v-if="false" :label="translateWords.IsBig" width="1" show-overflow-tooltip></el-table-column>
          <el-table-column prop="IsBigStr" v-if="false" :label="translateWords.IsBig" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ImgType" v-if="env != 'unico' && type != 'aigosampleformarketcenter'" :label="translateWords.ImgType" show-overflow-tooltip></el-table-column>
          <el-table-column prop="IsRequestByMultimedia" v-if="false" :label="translateWords.IsRequestByMultimedia" width="1"></el-table-column>
          <el-table-column prop="IsRequestByMultimediaStr" v-if="false" :label="translateWords.IsRequestByMultimedia"></el-table-column>
          <el-table-column prop="IsRequestByProductCenter" v-if="false" :label="translateWords.IsRequestByProductCenter" width="1"></el-table-column>
          <el-table-column prop="IsRequestByProductCenterStr" v-if="false" :label="translateWords.IsRequestByProductCenter"></el-table-column>

          <el-table-column prop="ExpectedShipmentDateTime" :label="translateWords.ExpectedShipmentDateTime" v-if="false"></el-table-column>
          <el-table-column
            prop="ExpectedShipmentDateTimeStr"
            v-if="env != 'unico' && type != 'aigosampleformarketcenter'"
            :label="translateWords.ExpectedShipmentDateTime"
            width="150"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column width="1" v-if="false" prop="PositionId" :label="translateWords.positionId"></el-table-column>

          <el-table-column width="1" v-if="false" prop="RackId" :label="translateWords.rackId"></el-table-column>

          <el-table-column width="200" prop="RackNo" :label="translateWords.rackNo" show-overflow-tooltip></el-table-column>
          <el-table-column width="200" prop="DepartMentName" :label="translateWords.gsgj" show-overflow-tooltip></el-table-column>
          <el-table-column width="200" prop="PositionName" :label="translateWords.positionName" show-overflow-tooltip></el-table-column>
          <el-table-column width="100" prop="Status" :label="translateWords.status" show-overflow-tooltip></el-table-column>
          <el-table-column prop="Remark" :label="translateWords.remark" width="200" show-overflow-tooltip></el-table-column>

          <el-table-column prop="ProductTypeCode" v-if="false" :label="translateWords.remark" width="1"></el-table-column>
          <el-table-column prop="StatusCode" v-if="false" :label="translateWords.remark" width="1"></el-table-column>

          <el-table-column :label="translateWords.operate" width="280" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" v-if="PermissonList.ChangeLog.value" @click="handleChangeLog(scope.row)">{{ translateWords.SampleChangeLog }}</el-button>
              <el-button size="mini" type="primary" v-if="PermissonList.Update.value" @click="handleEdit(scope.$index, scope.row)">{{ translateWords.edit }}</el-button>
              <el-button size="mini" type="primary" v-if="PermissonList.PutInStorage.value" @click="handlerk(scope.$index, scope.row)">{{ translateWords.scope }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin:1em 0"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100, 200]"
          :current-page="currPage"
          :page-size="pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog :visible.sync="dialogVisibleEditFromAGBS" width="70%" :show-close="true">
      <EditSampleFromAGBS ref="EditSampleFromAGBS" :PositionIdoptions="gsfjoptions" :title="title" @closedialogFromAGBS="closedialogFromAGBS"></EditSampleFromAGBS>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="closedialog();">关闭页面</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" width="70%" :show-close="true">
      <AddSample ref="AddSample" :PositionIdoptions="gsfjoptions" :title="title" @closedialog="closedialog"></AddSample>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="closedialog();">关闭页面</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblepladdsample" width="90%" :show-close="true">
      <!-- <PLAddSample ref="PLAddSample" :PositionIdoptions="gsfjoptions"  :title="title" @closedialog="closedialog" @reload="reload"></PLAddSample> -->
      <WP ref="WP" :guishufangjian="gsfjoptions"></WP>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="closedialogpladdsample();">关闭页面</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblerk" width="40%" :show-close="true">
      <RK ref="RK" @closedialogrk="closedialogrk"></RK>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="closedialogrk();">关闭页面</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblerkjl" width="90%" :show-close="true">
      <RKRecord ref="RKRecord"></RKRecord>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="closedialogrkjl();">关闭页面</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblekeyrecord" width="90%" :show-close="true">
      <SampleKeyRecord ref="SampleKeyRecord"></SampleKeyRecord>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="closedialogrkjl();">关闭页面</el-button> -->
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleAddSampleFromAGBS" width="90%" :show-close="true" append-to-body>
      <el-row>
        <el-button @click="SelectBar()">选中条码</el-button>
      </el-row>
      <el-row>
        <!-- 跟单人员: -->
        <el-input v-model="docusername" style="width:200px" v-show="false"></el-input>
        <el-table ref="temptableData" :data="temptableData" style="width: 100%">
          <el-table-column v-if="false" prop="Goods_Id" label="Id" width="1"></el-table-column>
          <el-table-column prop="Goods_Name2" :label="translateWords.ProductName" width="200"></el-table-column>
          <el-table-column width="200" prop="BarCode" :label="translateWords.ProductCode"></el-table-column>
          <el-table-column width="200" prop="Goods_BigClass" :label="translateWords.ProductType"></el-table-column>
          <el-table-column width="200" prop="Goods_Code" :label="translateWords.GoodsCode"></el-table-column>
          <el-table-column width="200" prop="DesignedForName" :label="translateWords.DesignedForName"></el-table-column>
          <el-table-column width="200" prop="Goods_Size1" :label="translateWords.GoodsSize"></el-table-column>
          <el-table-column width="200" prop="Unit" :label="translateWords.Unit"></el-table-column>

          <el-table-column width="200" prop="IsBig" :label="translateWords.IsBig">
            <template slot-scope="scope">
              <el-select v-model="scope.row.IsBig">
                <el-option v-for="el in Options.IsBig" :key="String(el.Code)" :label="el.Name" :value="String(el.Code)"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="ImgType" :label="translateWords.ImgType">
            <template slot-scope="scope">
              <el-select v-model="scope.row.ImgType">
                <el-option v-for="el in Options.ImgType" :key="String(el.Code)" :label="el.Name" :value="String(el.Code)"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="IsRequestByProductCenter" :label="translateWords.IsRequestByProductCenter">
            <template slot-scope="scope">
              <el-select v-model="scope.row.IsRequestByProductCenter">
                <el-option v-for="el in Options.IsOrNot" :key="String(el.Code)" :label="el.Name" :value="String(el.Code)"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="IsRequestByMultimedia" :label="translateWords.IsRequestByMultimedia">
            <template slot-scope="scope">
              <el-select v-model="scope.row.IsRequestByMultimedia">
                <el-option v-for="el in Options.IsOrNot" :key="String(el.Code)" :label="el.Name" :value="String(el.Code)"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="ExpectedShipmentDateTime" :label="translateWords.ExpectedShipmentDateTime">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.ExpectedShipmentDateTime" format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="ExpectedArrivalDateTime" :label="translateWords.ExpectedArrivalDateTime">
            <template slot-scope="scope">
              <el-date-picker v-model="scope.row.ExpectedArrivalDateTime" format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="SumStorage" :label="translateWords.SumStorage">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.SumStorage"></el-input>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="PositionId" :label="translateWords.positionName">
            <template slot-scope="scope">
              <el-select @change="selectvaluefortable(scope.row)" v-model="scope.row.PositionId" :placeholder="translateWords.positionName" filterable>
                <el-option v-for="item in gsfjoptions" :key="item.value" :label="item.label" :value="String(item.value)"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column width="200" prop="RackId" :label="translateWords.hjh">
            <template slot-scope="scope">
              <el-select v-model="scope.row.RackId" :placeholder="translateWords.selectRackLayer" filterable>
                <el-option v-for="item in scope.row.RackList" :key="item.value" :label="item.label" :value="String(item.value)"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="Status" :label="translateWords.Status">
            <template slot-scope="scope">
              <el-select v-model="scope.row.Status">
                <el-option v-for="el in Options.Status" :key="String(el.Code)" :label="el.Name" :value="String(el.Code)"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column width="200" prop="NewOrOld" v-if="env != 'unico' && type != 'aigosampleformarketcenter'" :label="translateWords.newOrOld">
            <template slot-scope="scope">
              <el-select v-model="scope.row.NewOrOld" :disabled="scope.row.IsDisabledNewOrOld">
                <el-option v-for="el in Options.NewOrOld" :key="String(el.Code)" :label="el.Name" :value="String(el.Code)"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="DocUserName" :label="translateWords.docusername">
            <template slot-scope="scope">
              <el-input v-model="scope.row.DocUserName"></el-input>
            </template>
          </el-table-column>
          <el-table-column width="200" prop="Remark" :label="translateWords.remark">
            <template slot-scope="scope">
              <el-input v-model="scope.row.Remark"></el-input>
            </template>
          </el-table-column>

          <el-table-column :label="translateWords.operate" width="300">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="rowdelete(scope.row)">{{ translateWords.Delete }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row></el-row>
      <el-row>
        <el-col :span="2">
          <el-button type="primary" @click="AddSampleFromAGBS()">提交</el-button>
        </el-col>
        <el-col :span="2"><el-button type="primary" @click="ExportFromAGBS()">导出</el-button></el-col>
        <el-col :span="2">
          <el-button type="primary" @click="downloadmodel()">导入模板下载</el-button>
        </el-col>
        <el-col :span="2">
          <el-upload v-if="PermissonList.UpLoad.value" class="upload-demo" ref="upload" action="" :file-list="fileList" :limit="1" :before-upload="beforeUploadfromagbs">
            <el-button slot="trigger" type="primary">导入</el-button>
            <div slot="tip" class="el-upload__tip"></div>
          </el-upload>
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleShowGetSampleFromAGBS" width="95%" :show-close="true" append-to-body>
      <el-row>
        <GetSampleFromAGBS ref="GetSampleFromAGBS" @loadtable="loadtable" @closedialogAGBS="closedialogAGBS"></GetSampleFromAGBS>
      </el-row>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisiblemodeload" width="30%" :before-close="handleClose">
      <table>
        <tr>
          <td>
            <div><a :href="cnspmoban">中文-导入商品新模板</a></div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <a :href="itspmoban">Italian-Importa un nuovo modello di prodotto</a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <a :href="spainspmoban">Spanish-Importar una nueva plantilla de productos</a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <a :href="enspmoban">English-Import a new product template</a>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div>
              <a :href="nlspmoban">Dutch-Een nieuw productsjabloon importeren</a>
            </div>
          </td>
        </tr>
      </table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblemodeload = false">{{ translateWords.closediag }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisibleShowSampleChangeLog" width="75%">
      <div slot="title">
        <span class="dialog-title">{{ translateWords.SampleChangeLog }}</span>
      </div>
      <SampleChangeLog :rowModel="currRowModel" v-if="dialogVisibleShowSampleChangeLog"></SampleChangeLog>
    </el-dialog>
  </div>
</template>

<script>
  import AddSample from '@/components/AddSample';
  import RK from '@/components/RK';
  import RKRecord from '@/components/RKRecord';
  import WP from '@/components/WP';
  import GetSampleFromAGBS from '@/components/GetSampleFromAGBS';
  import SampleKeyRecord from '@/components/SampleKeyRecord';
  import EditSampleFromAGBS from '@/components/EditSampleFromAGBS';
  import SampleChangeLog from '@/components/SampleChangeLog';

  import { importScript } from '../util/importScript';

  import global from './Global';
  export default {
    name: 'Sample',
    components: {
      AddSample,
      RK,
      RKRecord,
      WP,
      SampleKeyRecord,
      GetSampleFromAGBS,
      EditSampleFromAGBS,
      SampleChangeLog,
    },
    data() {
      return {
        translateWords: {
          inputCommodityName: '请输入商品名称',
          selectRackLayer: '请选择货架-货架层',
          gysdm: '请输入供应商代码',
          query: '查询',
          status: '状态',
          gsgj: '所属国家',
          openrkrecord: '出入库记录查询',
          loadCommodity: '上传商品',
          countStort: '上传盘点库存',
          model: '商品模板',
          repertoryModel: '库存盘点模板',
          code: '编码',
          commodityName: '商品名称',
          commodityBarCode: '商品条码',
          commodityClassis: '商品类别',
          supplierCode: '供应商代码',
          newOrOld: '新旧品',
          sumStorage: '总库存',
          canBeUseStorage: '可借库存',
          positionId: '位置',
          rackId: '货架-货架层',
          rackNo: '货架-货架层',
          positionName: '位置',
          remark: '备注',
          status: '状态',
          operate: '操作',
          edit: '编辑',
          scope: '入库',
          selectstatus: '请选择状态',
          hjh: '货架号',
          selectneworold: '请选择新旧品',
          Export: '导出数据',
          //下面是方法中的词条
          addSample: '新增样品',
          getRackFail: '获取货架失败',
          uploadTip: '只能上传  xls / xlsx 格式!',
          maxSize: '文件最大2M!',
          uploadSuccess: '上传成功',
          excelTip: '上传0条，请确认excel文件是否符合模版标准',
          getDataError: '归属房间下拉数据加载出错',
          EditSample: '编辑样品',
          delSuccess: '删除成功',
          delSampleFail: '删除样品信息出错',
          SampleManage: '样品管理',
          pladdsample: '批量新增样品',
          DepartmentName: '所属国家',
          searchdepartmentid: '查看本国编码',
          modeldownload: '多国语言商品模板下载',
          closediag: '关闭',
          querykey: '查询钥匙',
          ModelType: '型号',
          productremark: '产品类别编码名称对应关系',
          ProductName: '商品名称',
          ProductCode: '商品条码',
          ProductType: '商品类别',
          GoodsCode: '商品编码',
          GoodsSize: '最小包装规格',
          Unit: '单位',
          IsBig: '是否大货样',
          ImgType: '图片类型',
          DesignedForName: '专供属性',
          IsRequestByProductCenter: '样品是否产品中心发起借用申请',
          IsRequestByMultimedia: '样品是否多媒体部自动发起借用申请',
          ExpectedShipmentDateTime: '预计出货时间',
          ExpectedArrivalDateTime: '预计到货时间',
          SumStorage: '入库数量',
          Position: '位置',
          Rack: '货架层',
          Status: '是否启用',
          Delete: '删除',
          Source: '入库来源',
          docusername: '跟单人员',
          SampleChangeLog: '变动记录',
        },

        Options: {
          IsOrNot: [
            { Code: '', Name: '请选择' },
            { Code: '1', Name: '是' },
            { Code: '0', Name: '否' },
          ],
          IsBig: [
            { Code: '1', Name: '是' },
            { Code: '0', Name: '否' },
          ],
          Status: [
            { Code: '1', Name: '启用' },
            { Code: '0', Name: '禁用' },
          ],
          // RackList:[],
          ImgType: [{ Code: '1', Name: '大货样' }],
          NewOrOld: [
            { Code: '', Name: '请选择' },
            { Code: '新品', Name: '新品' },
            { Code: '旧品', Name: '旧品' },
          ],
        },
        spmoban: this.baseurl + '/SampleManage/导入商品新模板.xls',
        kcmoban: this.baseurl + '/SampleManage/导入库存盘点模板.xls',
        batchdeletemoban: this.baseurl + '/SampleManage/样品批量删除模板.xls',
        batchupdaterackmoban: this.baseurl + '/SampleManage/样品批量修改货架模板.xls',
        batchupdateregionmoban: this.baseurl + '/SampleManage/样品批量修改区域模板.xls',
        batchupdatepositionmoban: this.baseurl + '/SampleManage/样品批量修改位置模板.xls',
        batchupdateproductpositionmoban: this.baseurl + '/SampleManage/批量修改样品位置模板.xls',
        batchupdatestoragemoban: this.baseurl + '/SampleManage/批量修改样品库存模板.xls',
        batchsplitsubcodemoban: this.baseurl + '/SampleManage/批量拆分样品库存位置模板.xls',
        batchaddstoragemoban: this.baseurl + '/SampleManage/批量入库模板.xls',
        cnspmoban: this.baseurl + '/SampleManage/导入商品新模板.xls',
        spainspmoban: this.baseurl + '/SampleManage/Spanish-Importar una nueva plantilla de productos.xls',
        itspmoban: this.baseurl + '/SampleManage/Italian-Importa un nuovo modello di prodotto.xls',
        enspmoban: this.baseurl + '/SampleManage/English-Import a new product template.xls',
        nlspmoban: this.baseurl + '/SampleManage/Dutch-Een nieuw productsjabloon importeren.xls',
        exporturl: this.baseurl + '/v1/api/sample/ExportDataTemplate',
        exportbatchupdateurl: this.baseurl + '/v1/api/sample/ExportBatchUpdateTemplate',
        spmc: '',
        spbm: '',
        IsCaseSensitive: -1,
        ztoptions: [],
        gsfjoptions: [],
        hjh: '',
        dialogVisible: false,
        dialogVisiblerk: false,
        dialogVisiblerkjl: false,
        dialogVisiblepladdsample: false,
        dialogVisiblemodeload: false,
        dialogVisiblekeyrecord: false,
        dialogVisibleAddSampleFromAGBS: false,
        dialogVisibleShowGetSampleFromAGBS: false,
        dialogVisibleEditFromAGBS: false, //编辑新版
        dialogVisibleShowSampleChangeLog: false, //库存变动记录
        currRowModel: null,
        total: 0,
        currPage: 1,
        pageSize: 10,
        isQuery: false,
        xjpoptions: [],
        gysdm: '',
        xjp: '',
        zt: '',
        gsfj: '',
        Source: 0,
        tableData: [],
        title: '新增样品',
        fileList: [],
        uid: this.$route.query.uid,
        token: this.$route.query.token,
        lang: this.$route.query.lang,
        type: this.$route.query.type,
        hjhoptions: [],
        departmentid: '',
        DepartmentDropList: [],
        countryid: '',
        productremark: '',
        temptableData: [],
        Sourceoptions: [
          { value: 0, label: '请选择入库来源' },
          { value: 1, label: 'OA入库' },
          { value: 2, label: 'PDA入库' },
        ],
        CaseSensitiveOptions: [
          { value: -1, label: '请选择是否区分大小写' },
          { value: 1, label: '是' },
          { value: 0, label: '否' },
        ],
        docusername: '',
        PageTitle: '',
      };
    },
    created() {
      this.PermissonList = global.methods.GetOaRight(
        this.$store.state.SampleModuleCode,
        this.$store.state.SamplePermissonList,
        this.$route.query.token,
        this.$http,
        this.oarighturl
      );
      this.getData();
      this.GetDropInit();
      this.getinitstatus();
      this.getneworold();
      this.getcountry();
      this.$bus.$on('closepage', () => {
        this.closedialogwp();
      });
      if (this.type == 'aigosampleformarketcenter') {
        this.PageTitle = '市场部中心物资库';
      } else this.PageTitle = '样品管理';
    },
    mounted() {
      var that = this;

      importScript(this.baseurl, () => {
        that.jsT = window.jsT;
        that.translateWord();
      });
    },
    methods: {
      handleClose() {},

      loadtable(table) {
        if (this.temptableData.length == 0) this.temptableData = table;
        else {
          for (var i = 0; i < table.length; i++) {
            // 条码主键唯一
            var isKey =
              this.temptableData.filter(function(v) {
                return v.Goods_Id == table[i].Goods_Id;
              }).length == 0;
            if (isKey) {
              this.temptableData.push(table[i]);
            } else {
              // 选择重复条码，数量+1
              var SumStorage = this.temptableData.filter(function(v) {
                return v.Goods_Id == table[i].Goods_Id;
              })[0]['SumStorage'];
              if (SumStorage != '') {
                this.temptableData.filter(function(v) {
                  return v.Goods_Id == table[i].Goods_Id;
                })[0]['SumStorage'] = SumStorage + 1;
              }
            }
          }
        }
      },
      closedialogAGBS() {
        this.dialogVisibleShowGetSampleFromAGBS = false;
      },
      rowdelete(row) {
        const newArray = this.temptableData.filter(function(v) {
          return v.Goods_Id != row.Goods_Id;
        });
        this.temptableData = newArray;
      },
      doshowkeyrecord() {
        this.dialogVisiblekeyrecord = true;
      },
      getproductremark() {
        this.productremark = this.remark;
      },
      downloadmodel() {
        var url = this.exporturl + '?token=' + this.token + '&lang=' + this.lang;
        window.open(url);
      },
      //批量修改位置
      downloadbatchupdate() {
        var url = this.exportbatchupdateurl + '?token=' + this.token + '&lang=' + this.lang;
        window.open(url);
      },
      getcountryid() {
        var params = new URLSearchParams();
        params.append('cmd', 'GetCountryID');
        params.append('uid', this.uid);
        this.$http.post(this.actionurl, params).then((res) => {
          this.countryid = res.data.Message;
        });
      },
      openaddsampleforagbs() {
        this.temptableData = [];
        this.docusername = '';
        this.dialogVisibleAddSampleFromAGBS = true;
      },
      //选中条码
      SelectBar() {
        this.dialogVisibleShowGetSampleFromAGBS = true;
        this.$nextTick(function() {
          this.$refs.GetSampleFromAGBS.cleartable();
          this.$refs.GetSampleFromAGBS.query();
        });
      },
      //翻译
      translateWord() {
        let that = this;
        if (window.jsT) {
          for (const key in that.translateWords) {
            this.translateWords[key] = window.jsT.T(that.translateWords[key]);
          }
          this.title = window.jsT.T(this.title);
        } else {
          console.log('翻译器没有加载成功');
        }
      },
      modelload() {
        this.dialogVisiblemodeload = true;
      },
      openaddsample() {
        this.title = this.translateWords.addSample;
        this.dialogVisible = true;
        this.$nextTick(function() {
          this.$refs.AddSample.initproduct('add', null);
        });
      },
      openaddplsample() {
        //this.$parent.init();
        this.dialogVisiblepladdsample = true;
      },
      openrkrecord() {
        this.dialogVisiblerkjl = true;
        this.$nextTick(function() {
          this.$refs.RKRecord.init();
          this.$refs.RKRecord.getData(1, 10);
        });
      },
      getcountry() {
        var params = new URLSearchParams();
        params.append('cmd', 'GetCountry');
        params.append('lang', this.lang);
        params.append('uid', this.uid);
        this.$http.post(this.actionurl, params).then((res) => {
          this.DepartmentDropList = res.data.Data;
        });
      },
      getinitstatus() {
        var params = new URLSearchParams();
        params.append('cmd', 'GetStatus');
        params.append('lang', this.lang);
        this.$http.post(this.actionurl, params).then((res) => {
          this.ztoptions = res.data.Data;
        });
      },
      getneworold() {
        var params = new URLSearchParams();
        params.append('cmd', 'GetNewOrOld');
        params.append('lang', this.lang);
        this.$http.post(this.actionurl, params).then((res) => {
          this.xjpoptions = res.data.Data;
        });
      },
      selectvalue(val) {
        this.getrack(val);
      },
      selectvaluefortable(val) {
        this.getrackfortable(val);
      },
      getrackfortable(row) {
        var that = this;

        var params = new URLSearchParams();
        params.append('positionid', row.PositionId);
        params.append('cmd', 'GetRackByPositionId');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            // row.RackList = res.data.Data;
            for (var i = 0; i < that.temptableData.length; i++) {
              if (that.temptableData[i].Goods_Id == row.Goods_Id) {
                //this.$nextTick(function () {
                that.$set(that.temptableData[i], 'RackList', res.data.Data);
                //that.temptableData[i].RackList=res.data.Data;
                that.temptableData[i].RackId = '';

                //  });
              }
            }
          } else {
            alert(that.translateWords.getRackFail + ',' + res.data.Message);
          }
        });
      },
      getrack(positionid) {
        var that = this;
        var params = new URLSearchParams();
        params.append('positionid', positionid);
        params.append('cmd', 'GetRackByPositionId');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            this.hjhoptions = res.data.Data;
          } else {
            alert(that.translateWords.getRackFail + ',' + res.data.Message);
          }
        });
      },

      handleUploadBeforeUpload(file, type) {
        var _this = this;
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        const extension = testmsg === 'xls' || testmsg === 'xlsx';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!extension) {
          alert(_this.translateWords.uploadTip);
          return false;
        }
        let fd = new FormData();
        fd.append('file', file);
        fd.append('uid', _this.uid);
        fd.append('type', type);
        fd.append('fromtype', _this.type);
        fd.append('cmd', 'UpLoadExcel');
        fd.append('env', _this.env);
        fd.append('filename', _this.guid() + '.' + testmsg);
        _this.$http.post(_this.actionurl, fd).then(function(res) {
          if (res.data.Message == '') {
            _this.getData();
            alert(_this.translateWords.uploadSuccess);
          } else {
            alert(res.data.Message);
          }
        });
      },
      //导出
      ExportFromAGBS() {
        if (this.temptableData.length == 0) {
          alert('当前没有任何数据');
          return;
        }
        var params = new URLSearchParams();
        params.append('List', JSON.stringify(this.temptableData));
        params.append('Lang', this.lang);
        this.$http({
          method: 'post',
          url: this.baseurl + '/SampleManage/DownLoadFromAGBS.aspx', //toxl  地址转换
          data: params,
          responseType: 'arraybuffer',
        }).then((response) => {
          this.download(response.data);
        });
      },
      //新增样品
      AddSampleFromAGBS() {
        if (this.temptableData.length == 0) {
          alert('当前无任何数据');
          return;
        }
        var el = null;
        var issave = true;
        for (var i = 0; i < this.temptableData.length; i++) {
          el = this.temptableData[i];
          if (el.IsRequestByMultimedia == '1' && (el.ExpectedShipmentDateTime == '' || el.ExpectedShipmentDateTime == null)) {
            issave = false;
            alert('多媒体自动发起需要填写预计出货时间，请重新选择');
            break;
          }
          if (el.IsRequestByMultimedia == '1' && (el.ExpectedArrivalDateTime == '' || el.ExpectedArrivalDateTime == null)) {
            issave = false;
            alert('多媒体自动发起需要填写预计到货时间，请重新选择');
            break;
          }
          if (el.IsRequestByProductCenter == '' || el.IsRequestByProductCenter == null) {
            issave = false;
            alert('请选择是否产品中心发起');
            break;
          }
          if (el.IsRequestByMultimedia == '' || el.IsRequestByMultimedia == null) {
            issave = false;
            alert('请选择是否多媒体中心发起');
            break;
          }
          if (el.SumStorage == '' || el.SumStorage == 0 || el.SumStorage == null || el.SumStorage == '') {
            issave = false;
            alert('请填写入库数量');
            break;
          }
          if (el.PositionId == '' || el.PositionId == '0' || el.PositionId == null) {
            issave = false;
            alert('请选择位置');
            break;
          }
          if (el.RackId == '' || el.RackId == '0' || el.RackId == null) {
            issave = false;
            alert('请选择货架');
            break;
          }
          if (el.NewOrOld == '' || el.NewOrOld == null) {
            issave = false;
            alert('请选择新旧品');
            break;
          }
          if (el.DocUserName == '' || el.DocUserName == null) {
            issave = false;
            alert('请填写跟单人员');
            break;
          }
        }
        if (!issave) return;
        var params = {};
        params.List = this.temptableData;
        params.DocUserName = this.docusername;
        this.$http
          .post(this.baseurl + '/v1/api/Sample/AddSampleFromAGBS', params, {
            headers: { Authorization: this.token },
          })
          .then((data) => {
            if (data.data == '') {
              alert('保存成功');
              this.query();
              this.dialogVisibleAddSampleFromAGBS = false;
            } else {
              alert(data.data);
            }
          });
      },

      //新版导入
      beforeUploadfromagbs(file) {
        var _this = this;
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
        const extension = testmsg === 'xls' || testmsg === 'xlsx';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!extension) {
          alert(_this.translateWords.uploadTip);
          return false;
        }

        let fd = new FormData();
        fd.append('file', file);
        fd.append('token', this.token);
        fd.append('lang', this.lang);
        fd.append('cmd', 'UpLoadExcelFromAGBS');
        fd.append('env', this.env);
        fd.append('filename', _this.guid() + '.' + testmsg);
        _this.$http.post(_this.actionurl, fd).then(function(res) {
          if (res.data.Message == '') {
            _this.loadtable(res.data.Data);
          } else {
            alert(res.data.Message);
          }
        });
      },
      guid() {
        function S4() {
          return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
      },
      GetDropInit() {
        var params = new URLSearchParams();
        params.append('lang', this.lang);
        params.append('uid', this.uid);
        params.append('cmd', 'InitDrop');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            this.gsfjoptions = res.data.Data.LoadDropPosition;
          } else {
            alert(this.translateWords.getDataError + res.data.Message);
          }
        });
      },
      query() {
        this.isQuery = true;
        this.getData(true);
      },
      closedialog() {
        this.dialogVisible = false;
        this.getData(true);
      },
      closedialogFromAGBS() {
        this.dialogVisibleEditFromAGBS = false;
        this.getData(true);
      },
      closedialogrk() {
        this.dialogVisiblerk = false;
        this.getData(true);
      },
      closedialogwp() {
        this.dialogVisiblepladdsample = false;
        this.getData(true);
      },

      getData(isFirstLoad = false) {
        var params = new URLSearchParams();
        if (isFirstLoad) {
          this.currPage = 1;
        }
        params.append('pageIndex', this.currPage);
        params.append('pageSize', this.pageSize);
        params.append('uid', this.uid);
        params.append('lang', this.lang);
        params.append('cmd', 'LoadSample');
        params.append('type', this.type);
        params.append('env', this.env);
        if (this.isQuery) {
          params.append('spmc', this.spmc);
          params.append('spbm', this.spbm);
          params.append('gsfj', this.gsfj);
          params.append('hjh', this.hjh);
          params.append('gysdm', this.gysdm);
          params.append('xjp', this.xjp);
          params.append('zt', this.zt);
          params.append('source', this.Source);
          params.append('DepartMentID', this.departmentid);
          params.append('iscasesensitive', this.IsCaseSensitive);
        }
        this.$http.post(this.actionurl, params).then((res) => {
          this.tableData = res.data.Data.list;
          this.total = res.data.Data.total;
          this.getcountryid();
          this.getproductremark();
        });
      },
      handlerk(index, row) {
        this.dialogVisiblerk = true;
        this.$nextTick(function() {
          this.$refs.RK.initform(row);
        });
      },
      exprotexcel() {
        var params = new URLSearchParams();
        params.append('spmc', this.spmc);
        params.append('spbm', this.spbm);
        params.append('gsfj', this.gsfj);
        params.append('hjh', this.hjh);
        params.append('gysdm', this.gysdm);
        params.append('xjp', this.xjp);
        params.append('zt', this.zt);
        params.append('lang', this.lang);
        params.append('departmentid', this.departmentid);
        params.append('uid', this.uid);
        params.append('env', this.env);
        this.$http({
          method: 'post',
          url: this.baseurl + '/SampleManage/DownLoad.aspx', //toxl  地址转换
          data: params,
          responseType: 'arraybuffer',
        }).then((response) => {
          this.download(response.data);
        });
      },
      download(data) {
        if (!data) {
          return;
        }
        let url = window.URL.createObjectURL(new Blob([data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.download = '下载.xls'; //下载后文件名
        link.setAttribute('download', '下载.xls');
        document.body.appendChild(link);
        link.click();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.currPage = 1;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currPage = val;
        this.getData();
      },
      handleEdit(index, row) {
        this.type = 'edit';
        this.title = this.translateWords.EditSample;
        if (this.env == 'unico' || this.type == 'aigosampleformarketcenter') {
          //unico以及原来的样品旧的处理方式
          this.dialogVisible = true;
          this.$nextTick(function() {
            this.$refs.AddSample.initproduct('edit', row);
            this.$refs.AddSample.setwp(false);
            this.$refs.AddSample.setwpbutton(false);
            this.$refs.AddSample.getrack(row.PositionId);
          });
        } else {
          this.dialogVisibleEditFromAGBS = true;
          this.$nextTick(function() {
            this.$refs.EditSampleFromAGBS.initproduct('edit', row);

            this.$refs.EditSampleFromAGBS.getrack(row.PositionId);
          });
        }
      },
      handleDelete(index, row) {
        var that = this;
        var params = new URLSearchParams();
        params.append('id', row.Id);
        params.append('cmd', 'DeleteSampleProduct');
        this.$http.post(this.actionurl, params).then((res) => {
          if (res.data.Message == '') {
            alert(that.translateWords.delSuccess);
            this.getData(true);
          } else {
            alert(that.translateWords.delSampleFail + res.data.Message);
            // this.$message({
            //   message: res.data.Message,
            //   type: "error"
            // });
          }
        });
      },
      handleChangeLog(row) {
        this.currRowModel = row;
        this.dialogVisibleShowSampleChangeLog = true;
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .my-page {
    text-align: initial !important;
  }

  .page-title {
    font-weight: bold;
    margin: 0px 0px 15px;
    font-size: 26px;
  }

  .dialog-title {
    font-weight: bold;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sample.vue